setMenuData